import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

const statusColors = {
  active: "bg-emerald-100 text-emerald-700",
  expired: "bg-red-100 text-red-700",
  draft: "bg-gray-100 text-gray-600",
};

const statusLabels = {
  active: "Activo",
  expired: "Vencido",
  draft: "Borrador",
};

const UpdateLibrary = ({ updates, selectedUpdate, onSelectUpdate, onUploadClick }) => {
  return (
    <div className="flex flex-col h-full" style={{ background: "var(--color-card)", borderRadius: "var(--radius-lg)", boxShadow: "var(--shadow-md)" }}>
      <div className="flex items-center justify-between px-4 py-3 border-b" style={{ borderColor: "var(--color-border)" }}>
        <h2 className="font-heading font-bold text-base" style={{ color: "var(--color-foreground)" }}>
          Biblioteca de Actualizaciones
        </h2>
        <Button variant="default" size="sm" iconName="Upload" iconPosition="left" onClick={onUploadClick}>
          Nueva
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto scrollbar-thin p-2">
        {updates?.map((u) => (
          <div
            key={u?.id}
            onClick={() => onSelectUpdate(u)}
            className={`flex flex-col gap-1 p-3 rounded-lg mb-2 cursor-pointer transition-base border ${selectedUpdate?.id === u?.id ? "border-teal-500 bg-teal-50" : "border-transparent hover:bg-gray-50"}`}
            style={{ borderColor: selectedUpdate?.id === u?.id ? "var(--color-primary)" : "transparent" }}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex items-center gap-2 min-w-0">
                <div className="w-8 h-8 rounded-md flex items-center justify-center flex-shrink-0" style={{ background: "var(--color-muted)" }}>
                  <Icon name="Package" size={16} color="var(--color-primary)" />
                </div>
                <div className="min-w-0">
                  <p className="font-caption font-semibold text-sm truncate" style={{ color: "var(--color-foreground)" }}>{u?.name}</p>
                  <p className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>v{u?.version}</p>
                </div>
              </div>
              <span className={`text-xs font-caption px-2 py-0.5 rounded-full flex-shrink-0 ${statusColors?.[u?.status]}`}>{statusLabels?.[u?.status]}</span>
            </div>
            <div className="flex items-center gap-3 mt-1 pl-10">
              <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                <Icon name="HardDrive" size={11} className="inline mr-1" />{u?.fileSize}
              </span>
              <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                <Icon name="Calendar" size={11} className="inline mr-1" />{u?.uploadDate}
              </span>
              <span className="font-caption text-xs" style={{ color: "var(--color-muted-foreground)" }}>
                <Icon name="Users" size={11} className="inline mr-1" />{u?.assignedCount} asignados
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UpdateLibrary;